/**
 * 正整数校验
 */
export const REG_POSITIVE_INTEGER = /(^[1-9]\d*$)/

/**
 * 正数（有小数）校验
 */
export const REG_POSITIVE = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/

/**
 * 英文字母大小写、正整数
 */
export const REG_ALPHA_POSITIVE_INTEGER_ZERO = /^[a-zA-Z0-9]+$/

/**
 * 手机号：只能输入+或者数字
 */
export const REG_MOBILE = /^\+?\d+(#\d+)?$/

export const REG_EMAIL = /^([A-Za-z0-9_\-\+\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/

/** 商品英文品名 */
export const REG_EN_NAME = /^[0-9a-zA-Z\\_-\s`~!@#¥$%^&*()+=|{}':;',\/\[\].<>?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]+$/

/** 商品中文品名（至少包含1个中文字符） */
export const REG_ZH_NAME = /[\u4e00-\u9fa5]/

/** 商家订单号 */
// \[\]
export const ORDER_NO_REG = /^[0-9a-zA-Z\s\+\-=_#（）()\/\\\*%\！\·\￥\$\^\@\&]+$/

/**url */
export const URL_REG = /^\w+[^\s]+(\.[^\s]+){1,}$/

/** sku 编辑支持特殊字符 */
export const REG_SKU_CODE = /^[\s\w-.*+\/%_#\$]+$/
